import {
  CustomRewardExperience,
  IRLPrizeType,
} from '@sorare/core/src/__generated__/globalTypes';
import { RewardWithExperiencesType } from '@sorare/core/src/lib/rewards';

export const isExperienceType = (
  type: RewardWithExperiencesType
): type is CustomRewardExperience | IRLPrizeType =>
  type in CustomRewardExperience || type in IRLPrizeType;
